module.exports = __webpack_public_path__ + "img/GBM1_B.c198f843.png";